import { P } from "@quarks";
import styled from "styled-components";

export const SectionDescription = styled(P)`
  color: ${({ theme }) => theme.text.color.subtitle};
`;
